exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-dialog>.v-card>.v-card__actions[data-v-789ee156]{padding:10px 10px}.v-card__subtitle[data-v-789ee156],.v-card__text[data-v-789ee156]{font-size:1rem;font-weight:500;line-height:1.375rem;letter-spacing:.0071428571em}.v-stepper__content[data-v-789ee156]{overflow-y:scroll}.v-stepper__content h2[data-v-789ee156]{font-weight:500;margin-top:24px;font-size:1.2em}.v-stepper__content .input-row[data-v-789ee156]:not(:first-child){border-top:1px solid #d3d3d3;margin-top:24px}.sdr-custom-tab-active[data-v-789ee156]{color:#ab3b7a!important}.sdr-custom-tabs .v-item-group[data-v-789ee156]{padding-left:0}", ""]);

// exports
